import React from 'react';
import radium from 'radium';
import earHairImage from '../../static/images/earHair.png';

const styles = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 150px)',
    padding: 20,
  },
  image: {
    maxWidth: '100%',
    maxHeight: 'calc(100% - 60px)',
  },
};

function EarHair() {
  return (
    <div style={styles.wrap}>
      <img role="presentation" src={earHairImage} style={styles.image} />
    </div>
  );
}

export default radium(EarHair);



// WEBPACK FOOTER //
// ./components/EarHair/EarHair.js